export const PRODUCT_NAME = 'Bridge';
export const PARTNER_NAME = 'Digital Connectivity';

/**
 * Generate service name based on environment
 * @param env The environment string ('dev', 'test', 'prod', etc.)
 * @returns Service name in format 'ground-control-web-{env}'
 */
export function getServiceName(env: string): string {
  return `ground-control-web-${env}`;
}

export const METADATA = {
  PRODUCT_NAME,
  PARTNER_NAME,
  getServiceName
};